export default "__VITE_ASSET__GSZD1N$f__"